'use client';

import { FC, useContext, useState } from 'react';
import { WithEmailFlowProps } from './WithEmailFlow.types';
import {
  Button,
  ButtonGroup,
  Flex,
  Separator,
  Heading,
  Text,
} from '@/_components';
import { UserContext } from '@/_contexts/UserProvider';
import { setSignInMethod } from '@/_api/users';
import { ToastContext } from '@/_contexts/ToastProvider';

export const WithEmailFlow: FC<WithEmailFlowProps> = ({ onUpdate }) => {
  const { addToast } = useContext(ToastContext);
  const { user, token } = useContext(UserContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async () => {
    let isUpdated: boolean = false;
    setIsLoading(true);

    try {
      await setSignInMethod({
        signInMethod: 'email',
        email: user?.email!,
        token,
      });

      isUpdated = true;
      addToast('success', 'Sign-in preference updated successfully');
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      setIsLoading(false);
      onUpdate(isUpdated, 'email');
    }
  };

  const onCancel = () => onUpdate(false);

  return (
    <Flex isColumn={true} gap={8}>
      <Flex isColumn={true} gap={2}>
        <Heading level={3}>Update sign-in method</Heading>
        <Text type="small">
          We&apos;ll send you a code via email the next time you log in: <br />
          <b>{user?.email}</b>.
        </Text>
      </Flex>
      <Separator />
      <ButtonGroup align="right">
        <Button
          value="Cancel"
          intent="secondary"
          onClick={onCancel}
          isDisabled={isLoading}
        />
        <Button
          value="Update"
          intent="primary"
          onClick={onSubmit}
          isLoading={isLoading}
          isDisabled={isLoading}
        />
      </ButtonGroup>
    </Flex>
  );
};
